import { AxiosRequestConfig } from 'axios';
import { APP_URL } from 'shared/constants/common';
import { CurrencyCode } from '../features/offers/interface/offers.interface';

export type PaymentDepositRequest = {
	providerId: number;
	transactionAmount: string;
	customer: {
		email: string;
	};
	additionalData: string;
	voucherCode?: string;
	accountId?: number | null;
};

type PaymentProcessRequest = {
	providerId: number;
	transactionAmount: string;
} & (
	| {
			card: {
				creditCardId: number | null;
			};
	  }
	| {
			customer: {
				email: string;
			};
			additionalData: string;
	  }
);

const CustomerApiWrapper = (requests: any) => {
	return {
		getCustomerAndAccountData: () => {
			return requests.get(`customer/account/information`);
		},

		getConsents: () => {
			return requests.get(`customer/account/consents`);
		},

		updateConsents: (data: any) => {
			return requests.post(`customer/account/consents`, data);
		},

		getLimitInfo: () => {
			return requests.get(`customer/account/limit`);
		},

		updateLimits: (data: any) => {
			return requests.put(`customer/account/limit`, data);
		},

		getTransactionsTransfer: (queryParams: any) => {
			const config: AxiosRequestConfig = {
				headers: {
					'Request-Language': 'pl',
				},
				params: queryParams,
			};
			return requests.get(`transaction/transfers/by-date`, config);
		},

		getSessionHistory: (queryParams: any) => {
			const config: AxiosRequestConfig = {
				params: queryParams,
			};
			return requests.get(`customer/session/history`, config);
		},

		closeAccount: () => {
			return requests.post(`customer/account/close`);
		},

		selfExclusion: (data: any) => {
			return requests.post(`customer/account/self-exclusion`, data);
		},

		payout: (data: any) => {
			return requests.post(`payments/payout`, data);
		},
		verifyAccount: (formData: any) => {
			const config: AxiosRequestConfig = {
				headers: {
					'Content-Type': 'multipart/form-data',
				},
			};
			return requests.post(`customer/account/verification-finish`, formData, config);
		},
		getPaymentConfig: () => {
			return requests.get(`payments/config`);
		},
		deposit: (data: PaymentDepositRequest) => {
			return requests.post(`payments/deposit`, {
				callbackUrl: `${window.location.origin}${APP_URL.home}`,
				transactionCurrency: CurrencyCode.PLN,
				...data,
			});
		},
		saveCard: (data: any) => {
			return requests.post(`payments/payment/verify`, data);
		},
		process: (data: PaymentProcessRequest) => {
			return requests.post(`payments/process`, {
				callbackUrl: `${window.location.origin}${APP_URL.home}`,
				transactionCurrency: CurrencyCode.PLN,
				...data,
			});
		},
		initialize: (data: any) => {
			return requests.post(`payments/initialize`, data);
		},
		startTransfer: (transactionId: string) => {
			return requests.post(`payments/start-transfer/${transactionId}`);
		},
		getSavedCreditCards: (providerId: number) => {
			return requests.get(`/payments/credit-card/list/${providerId}`);
		},
		updateCardVisibility: (data: { activeCard: boolean; creditCardId: number }) => {
			return requests.post(`/payments/credit-card/update`, data);
		},
		getVipData: () => {
			return requests.get(`/customer/segmentation/vip/level`);
		},
		getDepositMessage: () => {
			return requests.get(`payments/status`);
		},

		CustomStakes: (data: { defaultStakes: number[] }) => {
			return requests.put(`/player-profiles`, data);
		},
	};
};

export default CustomerApiWrapper;
